import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ImpactSection from './components/ImpactSection';
import WhatIsDoggy from './components/WhatIsDoggy';
import Minigame from './components/Minigame';
import { CommunityTours, CommunityHeroes } from './components/Community';
import BuyDoggy from './components/BuyDoggy';
import Footer from './components/Footer';
import './Landing.css';

/**
 * Landing Page Principal - DOGGY
 * Para personas que escanean QR en la calle (normies)
 * Mobile-first design
 */
const Landing = () => {
  return (
    <main className="landing">
      {/* Header fijo con CTA */}
      <Header />
      
      {/* SECCIÓN 1: Hero - 5 segundos para capturar */}
      <Hero />
      
      {/* SECCIÓN 2: Impacto Visual - Prueba social con números */}
      <ImpactSection />
      
      {/* SECCIÓN 3: ¿Qué es DOGGY? - Explicación simple */}
      <WhatIsDoggy />
      
      {/* SECCIÓN 4: Shark Tank + Doggy Tours */}
      <CommunityTours />
      
      {/* SECCIÓN 5: Minigame - Doggy Jump */}
      <Minigame />
      
      {/* SECCIÓN 6: La Manada - Héroes de la comunidad (OCULTO por founders) */}
      {/* <CommunityHeroes /> */}
      
      {/* SECCIÓN 7: Comprar DOGGY - CTA Final */}
      <BuyDoggy />
      
      {/* SECCIÓN 7: Footer */}
      <Footer />
    </main>
  );
};

export default Landing;
